import { ClientController, BlastworksClientEvent } from 'client-controller';
import { PYLLuckyPressBonusState } from 'states/pyl-lucky-press-bonus-state';

/**
 * Social bonus state to send client messages
 *
 * @class SocialLuckyPressBonusState
 * @typedef {SocialLuckyPressBonusState}
 * @extends {PYLLuckyPressBonusState}
 */
export class SocialLuckyPressBonusState extends PYLLuckyPressBonusState {
  /**
   * Send bonus start message
   *
   * @public
   * @override
   * @param {?boolean} [cascadeSkip]
   */
  public onEnter(cascadeSkip?: boolean): void {
    ClientController.getInstance().raiseEvent(BlastworksClientEvent.BONUS_START);
    super.onEnter(cascadeSkip);
  }

  /**
   * Send bonus complete message
   *
   * @public
   * @override
   */
  public onExit() {
    ClientController.getInstance().raiseEvent(BlastworksClientEvent.BONUS_COMPLETE);
    super.onExit();
  }
}
